import React, { Component, useEffect, useState } from "react";
import Joi from "joi-browser";
import Form from "../comman/form";
import http from "../services/HttpService";
import config from "../config.json";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginStep2 from "./Auth/LoginStep2";
import LoginStep1 from "./Auth/LoginStep1";
import ForgetPassword from "./ForgetPassword";
import LoginHeader from "./Auth/LoginHeader";
import LoginFooter from "./Auth/LoginFooter";
import { withMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, getLoggedUser, getLoginFailedStatus, loginFailed, sign, validateAdUser } from "../app/store/auth";
import {
  LOGIN_REQUEST,
  PUBLIC_CLIENT_APPLICATION,
  TOKEN_REQUEST,
} from "../msalConfig";

const AdminLogin = () => {


  const [validId, setValidId] = useState("");
  const [userName, setUserName] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [stateErrors, setStateErrors] = useState("");
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [loginBy, setLoginBy] = useState(null);
  const [interactionInProgress, setInteractionInProgress] = useState(false);

  const usrType = localStorage.getItem("userType");

  const loggedUserSeletor = useSelector(getLoggedUser);
  const loginFailedStatusSelector = useSelector(getLoginFailedStatus);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    const state = location.state;
    if (state?.validId) {
      setValidId(state.validId);
      setStep1(false);
      setStep2(true);
    }
  }, []);

  useEffect(() => {
    if (
      loggedUserSeletor.user &&
      !loggedUserSeletor.token &&
      loginBy !== "ad"
    ) {
      localStorage.setItem("tempPwd", userPwd);
      navigate("/ValidateUser");
    } else {
      if (currentUser) {
        setInteractionInProgress(false);
        navigate("/");
      }
    }
    if (currentUser) {
      setInteractionInProgress(false);
      navigate("/");
    }
  }, [loggedUserSeletor]);

  useEffect(() => {
    if (loginFailedStatusSelector !== "") {
      setStateErrors("Username or password is incorrect");
      dispatch(loginFailed(""))
    }
  }, [loginFailedStatusSelector])

  const handleStep1 = (step1Data) => {
    if (step1Data?.validId) {
      setStep1(false);
      setStep2(true);
      setValidId(step1Data.validId);
    }
  };

  const doSubmit = async (step2Data) => {
    dispatch(sign(step2Data.username, step2Data.password));
    setUserName(step2Data.username);
    setUserPwd(step2Data.password);
  };

  const handleBack = () => {
    setStep1(true);
    setStep2(false);
    setValidId("");
    localStorage.removeItem("userType");
  };

  const handleForgotPwd = () => {
    navigate("/ForgotPassword", { state: { validId } });
  }

  const handleSignIn = async () => {
    try {
      setInteractionInProgress(true);
      const loginResponse = await PUBLIC_CLIENT_APPLICATION.loginPopup(
        LOGIN_REQUEST
      );
      if (loginResponse.account) {
        PUBLIC_CLIENT_APPLICATION.setActiveAccount(loginResponse.account);
      }
      const tokenResponse = await PUBLIC_CLIENT_APPLICATION.acquireTokenSilent(
        TOKEN_REQUEST
      );
      //localStorage.setItem("loginType", "ad");
      setLoginBy("ad");
      dispatch(validateAdUser(tokenResponse.uniqueId, tokenResponse.accessToken));
    } catch (error) {
      setInteractionInProgress(false);
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      {step1 && <div className="col-md-12 d-flex align-items-center" style={{ height: "calc(100vh - 276px)" }}>

        <div className="row d-flex justify-content-center">
          <div className="col-md-5 d-flex align-items-stretch pr-0 pl-0">
            <div
              className="card shadow-none border rounded-0"
              style={{
                backgroundColor: "#eceff1",
                marginTop: "30px",
              }}
            >
              <div className="spacecl card-body d-flex align-items-center">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <h1>
                      Achieve agility and strategic business advantage
                      with WorkFINITY® technology framework
                    </h1>
                  </div>
                  <div className="col-md-12 text-center">
                    <h2>
                      Delivering next-generation, robust and scalable
                      digital service delivery platforms
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 pl-0 pr-0">
            <div
              className="card shadow-none border rounded-0"
              style={{
                backgroundColor: "#fafafa",
                marginTop: "30px",
              }}
            >
              <div className="spacecl card-body">
                <div className="text-center text-white mb-2">
                  <h2 className="text-black">SIGN IN</h2>
                </div>
                <LoginStep1
                  handleStep1={handleStep1}
                  userError={stateErrors}
                  type="admin"
                  handleAdLogin={handleSignIn}
                  interactionInProgress={interactionInProgress}
                ></LoginStep1>
                <Link
                  to="/ForgotValidID"
                  className="btn btn-link btn-sm"
                  style={{ float: "right" }}
                >
                  Forgot Your ID?
                </Link>
              </div>
            </div>
          </div>
          {/* <div className="col-md-10 pl-0 pr-0">
            {supportFooter()}
          </div> */}
        </div>
      </div>}

      {step2 && <div className="col-md-12">
        <div className="row d-flex justify-content-center align-items-center" style={{ height: "calc(100vh - 276px)" }}>
          <div className="col-md-5">
            <div
              className="cust-card-pp shadow-none border rounded-0"
              style={{
                backgroundColor: "#fafafa",
                marginTop: "0px",
              }}
            >
              <div className="pp-1 card-body">
                <div className="text-center text-white">
                  <h2 className="text-black">SIGN IN</h2>
                </div>
                <div>
                  <button
                    className="btn btn-link btn-sm"
                    onClick={handleBack}
                  >
                    <i
                      className="fa fa-long-arrow-left"
                      aria-hidden="true"
                    ></i>
                    Back
                  </button>

                </div>
                <div>
                  <p className="form-control-label" >
                    User Type : {usrType}, Valid ID : {validId}
                  </p>
                </div>
                <LoginStep2
                  handleDoSubmit={doSubmit}
                  userError={stateErrors}
                  handleForgotPwd={handleForgotPwd}
                  type="admin"
                ></LoginStep2>

              </div>
            </div>

          </div>
          {/* <div className="col-md-7">
            {supportFooter()}
          </div> */}
        </div>
      </div>}

    </React.Fragment>
  );
}

export default withMsal(AdminLogin);
